// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDetail_wrapper__TiJqo"};